import { useAuthStore } from '@/store/auth'
import { useUIStore } from '@/store/ui'

export function useIsAdmin(): boolean {
  const user = useAuthStore((s) => s.user)
  const adminViewEnabled = useUIStore((s) => s.adminViewEnabled)
  return (user?.isAdmin ?? false) && adminViewEnabled
}
